import logo from '../assets/logo.png';
import banner from '../assets/cupimage.png';
import about from '../assets/about.png';
import mugimg from '../assets/mug.png';
import cardimg from '../assets/card.png';
import flower from '../assets/flower.png';
import coffee from '../assets/coffee.png';
import booklet from '../assets/booklet.png';
import tshirt from '../assets/tshirt.png';
import paper from '../assets/paper.png';
import mock from '../assets/mock.png';






export default {
    logo,
    banner,
    about,
    mugimg,
    cardimg,
    flower,
    coffee,
    booklet,
    tshirt,
    paper,
    mock,
}